const ru = {
    translations: {
        "PagesNames.Cards": "Карты",
        "PagesNames.Operations": "Операции",
        "PagesNames.Devices": "Устройства",
        "PagesNames.Tanks": "Резервуары",
        "PagesNames.Limits": "Лимиты",
        "PagesNames.Administration": "Администрирование",
        "PagesNames.UserManagement": "Управление пользователями",
        "PagesNames.RoleManagement": "Управление ролями",
        "PagesNames.OrderHistory": "История изминений",
        "Header.LogoutText": "Вийти",
        "Table.Empty": "Список пустой",
        "Table.saveButton": "Сохранить",
        "Table.cancelButton": "Отмена",
        "Cards.editCardHeader": "Редактирование карты",
        "Cards.newCardHeader": "Новая карта",
        "Cards.cardNumber": "Номер карты",
        "Cards.cardRfidNumber": "Номер RFID",
        "Cards.cardIButtonNumber": "Номер iButton",
        "Cards.userName": "Сотрудник",
        "Cards.car": "Авто",
        "Cards.description": "Примечание",
        "Cards.cardType": "Тип карты",
        "Cards.avtoCardType": "Авто",
        "Cards.userCardType": "Сотрудник",
        "Cards.removeCardPopupHeader": "Удаление карточки",
        "Cards.removeCardPopupMessage": "Вы уверены что хотите удалить карту {card number}",
        "Cards.setOrderNumberPopupHeader": "Введите номер наряда",        
        "Cards.carNumber": "Номер кузова авто",
        "Cards.orderTs": "Дата наряд-заказа",
        "Cards.barcode": "Штрихкод",
        "CardsPagesNames.Cars": "Автомобили",
        "CardsPagesNames.Users": "Пользователи",
        "Devices.deviceImei": "Imei прибора",
        "Devices.name": "Имя прибора",
        "Devices.description": "Описание",
        "Devices.protocolType": "Тип протокола",
        "Devices.deviceType": "Тип устройства",
        "Devices.isActive": "Активный",
        "Devices.deviceIoSettings.volumeCountIoId": "Номер датчика обьема",
        "Devices.deviceIoSettings.volumeRatio": "Коэффициент преобразования",
        "Devices.deviceIoSettings.valveIoId": "Номер датчика клапана",
        "Devices.deviceIoSettings.userKeyIoId": "№ датчика чтения ключа водителя",
        "Devices.deviceIoSettings.autoKeyIoId": "№ датчика чтения ключа авто",
        "Devices.withLevelMetterText": "Установлен уровнемер",
        "Devices.levelMetterSettings.levelMeterInstallHeight": "Высота установки уровнемера",
        "Devices.levelMetterSettings.temperatureIoId": "Номер датчика температури",
        "Devices.levelMetterSettings.temperatureRatio": "Коэфициент преобразования температури",
        "Devices.levelMetterSettings.temperatureDelta": "Дэльта изменения температури",
        "Devices.levelMetterSettings.waterLevelMetterIoId": "Номер датчика уровня воды",
        "Devices.levelMetterSettings.watterLevelMetterRatio": "Коэфициент уровня воды",
        "Devices.levelMetterSettings.waterLevelMetterDelta": "Дэльта изменения уровня воды",
        "Devices.levelMetterSettings.productLevelMetterIoId": "Номер датчика уровня продукта",
        "Devices.levelMetterSettings.productLevelMetterRatio": "Коэфициент уровня продукта",
        "Devices.levelMetterSettings.productLevelMetterDelta": "Дэльта изменения уровня продукта",
        "Devices.levelMetterSettings.defaultDensity": "Плотность продукта по умолчанию",
        "Devices.levelMetterSettings.densityIoId": "Номер датчика плотности",
        "Devices.levelMetterSettings.densityRatio": "Коэфициент преобразования плотности",
        "Devices.levelMetterSettings.densityDelta": "Дэльта изменения плотности",
        "Operations.cardNumber": "Номер карты",
        "Operations.userName": "Механик",
        "Operations.car": "Авто",
        "Operations.operationTs": "Время операции",
        "Operations.startOperationTs": "Время начала операции",
        "Operations.endOperationTs": "Время окончания операции",
        "Operations.deviceImei": "Имей устройства",
        "Operations.rawVolumeData": "Необработаный обьем",
        "Operations.volume": "Обьем",
        "Operations.tankBalance": "Остаток в резервуаре",
        "Operations.limitBalance": "Остаток по лимиту",
        "UserManagement.userName": "Логин пользователя",
        "UserManagement.firstName": "Имя",
        "UserManagement.secondName": "Фамилия",
        "UserManagement.email": "Почта",
        "UserManagement.isActive": "Активный",
        "UserManagement.roleName": "Роль",
        "UserManagement.newPassword": "Новый пароль",
        "UserManagement.password": "Пароль",
        "UserManagement.confirmPassword": "Подтвердите пароль",
        "UserManagement.passwordAndConfirmNotEqualsError": "Подтвержение пароля должно быть таким же как пароль",
        "UserManagement.userNameEmptyError": "Имя пользователя не должно быть пустым",
        "Tanks.tankName": "Резервуар",
        "Tanks.volume": "Обьем",
        "Tanks.balance": "Остаток",
        "Tanks.minLevel": "Минимальный обьем",
        "Tanks.maxLevel": "Максимальный обьем",
        "Tanks.fuelType": "Тип топлива",
        "Tanks.fuelNumber": "Номер топлива",
        "Tanks.areaName": "Площадка",
        "Tanks.areaDescription": "Описание",
        "Tanks.department": "Подразделение",
        "Tanks.usedTankBalance": "Резервуар заполнен на",
        "Tanks.graduations": "Градуировка",
        "Tanks.LoLevelNotificationPopupHeader": "Низкий уровень в резервуарах",
        "Tanks.LoLevelNotificationPopupMessage": "Низкий уровень продукта в резервуарах {tanks}",
        "Tanks.Details.maxLevel": "Обьем резервуара",
        "Tanks.Details.calculatedVolume": "Вычисленный остаток",
        "TankOperation.tankName": "Резервуар",
        "TankOperation.userName": "Имя пользователя",
        "TankOperation.fuelType": "Тип топлива",
        "TankOperation.provider": "Поставщик",
        "TankOperation.description": "Коментарий",
        "TankOperation.balance": "Отгружено",
        "TankOperation.deliveryDate": "Время поставки",
        "TankOperation.completed": "Обработано",
        "TanksPagesNames.Tanks": "Резервуары",
        "TanksPagesNames.TankOperations": "Отгрузки по резервуарам",
        "TanksPagesNames.TanksStateOperations": "Изменения состояния резервуаров",
        "TanksOperations.Filter.tankName": "Резервуар",
        "TanksOperations.Filter.dateFrom": "Дата с:",
        "TanksOperations.Filter.dateTo": "Дата по:",
        "TankStateOperation.tankName": "Имя резервуара",
        "TankStateOperation.watterLevelHeight": "Уровень воды (мм)",
        "TankStateOperation.watterLevelVolume": "Уровень воды (л)",
        "TankStateOperation.productLevelHeight": "Уровень продукта (мм)",
        "TankStateOperation.productLevelVolume": "Уровень продукта (л)",
        "TankStateOperation.temperature": "Температура",
        "TankStateOperation.density": "Плотность",
        "TankStateOperation.weight": "Вес",
        "TankStateOperation.packageTs": "Время обновления",
        "TankStateOperation.densityUnit": "т/м3",
        "TankStateOperation.weightUnit": "т",
        "Operations.Filter.userName": "Сотрудник",
        "Operations.Filter.car": "Авто",
        "Operations.Filter.tankName": "Резервуар",
        "Operations.Filter.fuelType": "Тип топлива",
        "Operations.Filter.dateFrom": "Дата с:",
        "Operations.Filter.dateTo": "Дата по:",
        "TankStateOperation.Filter.tankName": "Резервуар",
        "TankStateOperation.Filter.dateFrom": "Дата с:",
        "TankStateOperation.Filter.dateTo": "Дата по:",
        "ExtendedIo.ioType": "Тип датчика",
        "ExtendedIo.ioDataType": "Тип данных",
        "ExtendedIo.ioAddress": "Адрес датчика",
        "ExtendedIo.ratio": "Коэффициент",
        "ExtendedIo.offset": "Смещение",
        "ExtendedIo.dataDelta": "Дельта",
        "ExtendedIo.defaultValue": "Значение по умолчанию",
        "ExtendedIo.ioDataAction": "Действие конвертации",
        "ExtendedIo.ioDataActionParam": "Параметр конвертации",
        "ExtendedIo.EditTankHeader": "Дополнительные датчики",
        "ExtendedIo.watterLevelHeightIoName": "Уровень высоты воды",
        "ExtendedIo.watterLevelVolumeIoName": "Уровень обьема воды",
        "ExtendedIo.productLevelHeightIoName": "Уровень высоты продукта",
        "ExtendedIo.producLevelVolumeIoName": "Уровень обьема продукта",
        "ExtendedIo.productLevelHeightIoQualityName": "Качество сигнала уровня высоты продукта",
        "ExtendedIo.watterLevelHeightIoQualityName": "Качество сигнала уровня высоты воды",
        "ExtendedIo.producLevelVolumeIoQualityName": "Качество сигнала уровня обьема продукта",
        "ExtendedIo.watterLevelVolumeIoQualityName": "Качество сигнала уровня обьема воды",
        "ExtendedIo.temperatureIoName": "Температура",
        "ExtendedIo.temperatureIoQualityName": "Качество сигнала температуры",
        "ExtendedIo.densityIoName": "Плотность",
        "ExtendedIo.densityIoQualityName": "Качество сигнала плотности",
        "ExtendedIo.pressureIoName": "Давление",
        "ExtendedIo.pressureIoQualityName": "Качество сигнала давления",
        "ExtendedIo.weightIoName": "Вес",
        "ExtendedIo.weightIoQualityName": "Качество сигнала датчика веса",
        "Popups.OkButtonText": "Ok",
        "Popups.YesButtonText": "Да",
        "Popups.NoButtonText": "Нет",
        "Popups.CancelButtonText": "Отмена",
        "LoginPage.UserPasswordError": "Логин или пароль введены неверно",
        "LoginPage.UnknownServerError": "Неизвестная ошибка",
        "LoginPage.UserNameText": "Логин:",
        "LoginPage.PasswordText": "Пароль:",
        "LoginPage.LoginButtonText": "Войти",
        "Limits.cardNumber": "Номер карты",
        "Limits.cardOwnerName": "Наряд",
        "Limits.fuelType": "Тип топлива",
        "Limits.dayLimit": "Дневной лимит",
        "Limits.monthLimit": "Месячный лимит",
        "Limits.dateLimit": "Лимит",
        "Limits.endDate": "Дата",
        "Limits.limitState": "Использование лимита",
        "Limits.isEnabled": "Лимит активный",
        "Limits.notUseLimitState": "Не использовать лимиты",
        "Limits.useLimitState": "Использовать лимиты",
        "Limits.stopSupplyState": "Прекратить выдачу продукта",
        "Limits.cardLimitsHeader": "Лимиты",
        "Limits.dayVolume": "Использовано за день",
        "Limits.monthVolume": "Использовано за месяц",
        "Limits.totalVolume": "Использовано всего",
        "Limits.publisherName": "Кто создал",
        "Limits.orderDate": "Дата лимита",
        "Limits.mechanicName": "Хто получил",
        "Limits.isFullyUsed": "Получено полностью",
        "Limits.isActive": "Активный",
        "Limits.onlyActiveFilter": "Активные",
        "Limits.onlyNotActiveFilter": "Не активные",
        "Limits.activityAllFilter": "Все",        
        "Limits.movingTs": "Дата перемещения",
        "Limits.movingNumber": "Номер перемещения", 
        "AccessLevel.Read": "Чтение",
        "AccessLevel.Write": "Запись",
        "RoleManagement.roleName": "Имя роли",
        "RoleManagement.roleDescription": "Описание",
        "RoleManagement.ModuleClaimsTitle": "Доступ к модулям",
        "RoleManagement.FieldClaimsTitle": "Доступ к полям",
        "RoleManagement.roleNameAlreadyExistsError": "Такое имя роли уже есть",
        "RoleManagement.removeRolePopupHeader": "Удаление роли",
        "RoleManagement.removeRolePopupMessage": "Вы уверены что хотите удалить роль {role name}?",
        "RoleManagement.Claims.Tanks": "Резервуары",
        "RoleManagement.Claims.Areas": "Площадки",
        "RoleManagement.Claims.TankOperations": "Операции резервуаров",
        "RoleManagement.Claims.Cards": "Карточки",
        "RoleManagement.Claims.Administration": "Администрирование",
        "OrderHistory.OrderId": "ID заказа",
        "OrderHistory.OrderNumber": "Авто/Пользователь",
        "OrderHistory.ActionType": "Тип действия",
        "OrderHistory.Description": "Суть изменений",
        "OrderHistory.PublisherName": "Кто сделал",
        "OrderHistory.ActionTs": "Время изменений"
    }
}

export default ru;